import React from 'react';
import { get, has } from 'lodash'
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';

import { withFilterCars } from './containers/containerFilterCars'
import FilterCarsItems from './../components/sections/cars/static.filterCarsItems'

import styles from './filterCarsTooltip.module.scss'
import variables from './../values.scss'

const HtmlTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: variables.tooltipBack,
    color: variables.tooltipText,
    opacity: 1,
    padding: '12px 10px',
    border: '0px solid transparent',
    borderRadius: "4px",
    fontSize: "0.85rem",
    fontWeight: "normal",
    fontFamily: variables.font1,
    "& > .MuiTooltip-arrow": {
      "&:before": {
        color: variables.tooltipBack,
      }
    }
  },
}))(Tooltip);

const DEFAULT_TITLE = "Фильтр не выбран"

const getItemsTooltip = props => {
  const { filterCarsListItems } = props
  var statuses = []
  var counter = 0
  var insideItems = [];

  Object.keys(filterCarsListItems).map((filterItem) => {
    switch (filterItem) {
      case (FilterCarsItems.brands.name): {
        if (filterCarsListItems[filterItem] && filterCarsListItems[filterItem].length > 0) {
          insideItems.push(
            <li key={counter}>
              <span className={styles.titleTooltip}>{FilterCarsItems.brands.title}</span>
              <span className={styles.contentTooltip}>{filterCarsListItems[filterItem].map((item, index) => { return index > 0 ? ', ' + item.label : item.label })}</span>
            </li>)
          counter++
        }

        return null;
      }
      case (FilterCarsItems.groups.name): {
        if (filterCarsListItems[filterItem] && filterCarsListItems[filterItem].length > 0) {
          insideItems.push(
            <li key={counter}>
              <span className={styles.titleTooltip}>{FilterCarsItems.groups.title}</span>
              <span className={styles.contentTooltip}>{filterCarsListItems[filterItem].map((item, index) => { return index > 0 ? ', ' + item.label : item.label })}</span>
            </li>)
          counter++
        }

        return null;
      }
      case (FilterCarsItems.types.name): {
        if (filterCarsListItems[filterItem] && filterCarsListItems[filterItem].length > 0) {
          insideItems.push(
            <li key={counter}>
              <span className={styles.titleTooltip}>{FilterCarsItems.types.title}</span>
              <span className={styles.contentTooltip}>{filterCarsListItems[filterItem].map((item, index) => { return index > 0 ? ', ' + item.label : item.label })}</span>
            </li>)
          counter++
        }

        return null;
      }
      case (FilterCarsItems.inMove.name): {
        if (filterCarsListItems[filterItem])
          statuses.push(FilterCarsItems.inMove.title)
        counter++

        return null;
      }
      case (FilterCarsItems.noData.name): {
        if (filterCarsListItems[filterItem])
          statuses.push(FilterCarsItems.noData.title)
        counter++

        return null;
      }
      case (FilterCarsItems.parking.name): {
        if (filterCarsListItems[filterItem])
          statuses.push(FilterCarsItems.parking.title)
        counter++

        return null;
      }
      default: return null;
    }
  })

  if (statuses.length > 0) {
    insideItems.push(
      <li key={counter}>
        <span className={styles.titleTooltip}>Статусы</span>
        <span className={styles.contentTooltip}>{statuses.map((item, index) => { return index > 0 ? ', ' + item : item })}</span>
      </li>)
    counter++
  }

  return <ul className={styles.tooltipTemplate}>{insideItems.length > 0 ? insideItems.map((item) => item) : DEFAULT_TITLE}</ul>
}

const FilterCarsTooltip = props => {
  return (
    <HtmlTooltip arrow title={getItemsTooltip(props)} placement="right">
      <div>
        {props.children}
      </div>
    </HtmlTooltip>
  )
}

export default withFilterCars(React.memo(FilterCarsTooltip))
